exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news_outstyle[data-v-58e067cf]{border-radius:5px;-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999}.msg_div[data-v-58e067cf]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}", ""]);

// exports
